import { EnumItem } from '@core/models/enum-item.model';
import { EstimateConfiguration } from '@interfaces/EstimateConfiguration';

export type SectionFilterItem = EnumItem<keyof EstimateConfiguration>;

export const SECTION_FILTERS_STORAGE_KEY = 'ESTIMATE_SECTION_FILTERS';

export const SECTION_FILTER_ITEMS: SectionFilterItem[] = [
  {
    key: 'hideSectionDates',
    titleKey: 'OPTIONS.DATES',
    selected: false
  },
  {
    key: 'hideSectionNotes',
    titleKey: 'OPTIONS.NOTES',
    selected: false
  },
  {
    key: 'hideSectionFees',
    titleKey: 'OPTIONS.FEES',
    selected: false
  },
  {
    key: 'hideSectionInternalFees',
    titleKey: 'OPTIONS.INTERNAL_FEES',
    selected: false
  },
  {
    key: 'hideSectionExpenses',
    titleKey: 'OPTIONS.EXPENSES',
    selected: false
  },
  {
    key: 'hideSectionBudgetPercentage',
    titleKey: 'OPTIONS.BUDGET_PERCENTAGE',
    selected: false
  }
];
